import Vue from 'vue'

import { Select, Option, Button, Message, Tooltip, Empty, Slider, Collapse, CollapseItem, MessageBox, Input, Loading, Switch, Radio, RadioGroup } from 'element-ui'

Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Empty)
Vue.use(Slider)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Input)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
// Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;